/**
 * LocalStorage store for tracking last seen MOTD checksum
 */
import { createLocalStorage } from '$utilities/storage';
import { writable } from 'svelte/store';

/**
 * Store the checksum of the last seen MOTD.
 * When the checksum changes, the MOTD should be shown again.
 */
export const motdLastSeenStore = createLocalStorage<string | null>('motd-last-seen-checksum', null);

/**
 * Session flag to track if MOTD was already shown in this session.
 * This prevents the modal from showing multiple times when navigating between admin pages.
 * Uses a global window flag to survive HMR and layout re-mounts.
 */
function createSessionFlag() {
	// Use window object to store flag across HMR/remounts
	if (typeof window !== 'undefined') {
		if (!window.__motdShownThisSession) {
			window.__motdShownThisSession = false;
		}
	}

	const { subscribe, set } = writable<boolean>(
		typeof window !== 'undefined' ? window.__motdShownThisSession : false
	);

	return {
		subscribe,
		set: (value: boolean) => {
			if (typeof window !== 'undefined') {
				window.__motdShownThisSession = value;
			}
			set(value);
		}
	};
}

export const motdShownThisSession = createSessionFlag();

// TypeScript declaration for window properties
declare global {
	interface Window {
		__motdShownThisSession?: boolean;
		__motdIsShowing?: boolean;
		__motdCheckRan?: boolean;
	}
}
